@use "~theme/typographyV2" as typography;
@use "./tokens";
@use "~theme/breakpoints";

.button {
  @include typography.button;
  color: var(--white);
  background-color: var(--blue-02);
  border-color: var(--blue-02);
  height: tokens.$button-standard-height;
  width: 102px;
  border-radius: 4px;
  border: solid 2px transparent;
  outline: none;
  cursor: pointer;

  &:focus {
    box-shadow: 0 0 12px var(--highlight-blue);
  }
}

.buttonV2 {
  @include typography.button;
  color: var(--blue-02);
  background-color: var(--white);
  border-color: var(--blue-01);
  height: tokens.$button-standard-height;
  width: 102px;
  border: 1px solid var(--blue-02);
  border-radius: 4px;
  outline: none;
  cursor: pointer;
  margin:5px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  padding: 0 8px;
  font-variant-numeric: tabular-nums;

  // &:focus {
  //   box-shadow: 0 0 12px var(--highlight-blue);
  // }
}

.small {
  width: 92px;
  padding: 0 8px;
  font-family: typography.$font-mont;
  font-weight: 500;
  font-style: normal;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0px;
  text-align: center;
  vertical-align: middle;
  text-transform: uppercase;
  box-sizing: border-box;
  font-variant-numeric: tabular-nums;

  @include breakpoints.desktop {
    font-weight: 400;
    font-style: normal;
    letter-spacing: 0px;
    line-height: 24px;

  }
}

.button:hover {
  background-color: var(--blue-01);
  border-color: var(--blue-01);
}

.button:active {
  @include tokens.button-highlight;
}

.buttonV2:hover {
  background-color: var(--white);
  border-color: var(--blue-01);
}

// .buttonV2:active {
//   @include tokens.button-highlight;
// }


.selected {
  background: var(--blue-01);
  color: var(--white);
}

.buttonV2.selected:hover {
  background: var(--blue-01);
  color: var(--white);
}
